<template>
  <div class="col-12 col-lg-2" v-if="getAuthUser.role_name.toLowerCase() !== 'observer'">
    <ul class="sidebar px-3 px-xl-4">
      <li class="sidebar__item">
        <router-link to="/dashboard" class="sidebar__link" active-class="active">Dashboard</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="getAuthUser.role_name === 'Admin'">
        <router-link to="/surveys" class="sidebar__link" active-class="active">Survey Management</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="getAuthUser.role_name === 'Admin'">
        <router-link to="/questions" class="sidebar__link" active-class="active">Survey Library</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="getAuthUser.role_name === 'Admin'">
        <router-link to="/users" class="sidebar__link" active-class="active">Users</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="['Admin', 'Partner Organisation'].includes(getAuthUser.role_name)">
        <router-link to="/monitors" class="sidebar__link" active-class="active">Monitors</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="getAuthUser.role_name === 'Admin'">
        <router-link to="/test-management" class="sidebar__link" active-class="active">Test Management</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="getAuthUser.role_name === 'Admin'">
        <router-link to="/countries" class="sidebar__link" active-class="active">Countries</router-link><span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="getAuthUser.role_name === 'Admin'">
        <router-link to="/pesticides"
                     class="sidebar__link"
                     :class="{active: ['Pesticides', 'Active Ingredients', 'Crops', 'Pests'].includes($route.name)}">Pesticides Reference</router-link>
        <span class="sidebar__toggle"></span>
      </li>
      <li class="sidebar__item" v-if="['Admin', 'Partner Organisation'].includes(getAuthUser.role_name)">
        <router-link to="/results" class="sidebar__link" active-class="active">Surveys Completed</router-link><span class="sidebar__toggle"></span>
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "Sidebar",
    computed: {
      ...mapGetters(['getAuthUser'])
    }
  }
</script>

<style>

</style>